import "../../assets/css/common/ErrorModal.css";

function ErrorModal({
  show,
  message,
  onClose,
  type = "error",
}) {
  if (!show) return null;

  return (
    <div
      className="error-modal-overlay"
      data-testid="error-modal"
    >
      <div className={`error-modal ${type}`}>
        <div className={`error-modal-body ${type}`}>
          <strong>
            {type === "success"
              ? "✅ Success!"
              : "❌ Error!"}
          </strong>

          <p>{message}</p>
        </div>

        <button
          className={type}
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default ErrorModal;


/*  Success modal example:

<ErrorModal
  show={showModal}
  type="success"
  message="Certificate generated successfully!"
  onClose={() => setShowModal(false)}
/>

  Error modal example:

<ErrorModal
  show={showModal}
  type="error"
  message="Failed to generate certificate."
  onClose={() => setShowModal(false)}
/>

*/